import React from 'react';

export const StatItem = (props: { children: React.ReactNode }) => {
    const { children } = props;

    return <div className="lesson-content__stat-detail">{children}</div>;
};
